import React from 'react';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';
import { FacebookSettings } from '../../facebook/components/FacebookSettings';
import { useIsFacebookEnabled } from '../../social-posting/hooks/useIsFacebookEnabled';
import { useIsInstagramEnabled } from '../../social-posting/hooks/useIsInstagramEnabled';
import { InstagramSettings } from '../../instagram/components/InstagramSettings';

export const TeamIntegrations = () => {
  useAnalyticsPage(Page.INTEGRATIONS);
  const { isFacebookEnabled } = useIsFacebookEnabled();
  const { isInstagramEnabled } = useIsInstagramEnabled();

  return (
    <div>
      <div className="integrations__container">
        {isFacebookEnabled && <FacebookSettings />}
        {isInstagramEnabled && <InstagramSettings />}
      </div>
    </div>
  );
};
